// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1nSJE","author":"Table_author__3buUs","authorImage":"Table_authorImage__10Y89","unreadRow":"Table_unreadRow__Dj85m"};